import { getPublicLocationCode, isMemberCountryCode } from "../../shared/location";

export const getOutwardPostcode = (
  postcode: string | null | undefined,
  countryCode?: string | null,
) => {
  return getPublicLocationCode(postcode, countryCode);
};

export const formatPublicLocation = (
  postcode: string | null | undefined,
  countryCodeOrFallback?: string | null,
  fallback = 'Local',
) => {
  const hasExplicitCountry = isMemberCountryCode(countryCodeOrFallback);
  const countryCode = hasExplicitCountry ? countryCodeOrFallback : null;
  const resolvedFallback = hasExplicitCountry ? fallback : (countryCodeOrFallback ?? 'Local');

  return getOutwardPostcode(postcode, countryCode) ?? resolvedFallback;
};
